import { toast } from "react-toastify";
import { api, api2, handleToast, reLoadPage } from "./config";



export async function AddBeneficiaries(data) {
    try {
        const res = await api.post('beneficiaries', data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': `Bearer ${localStorage.getItem('login')}`
            }
        });
        handleToast('success', 'حساب بانکی با موفقیت ثبت شد');
        return res;
    } catch (error) {
        if (error.request?.status === 401) {
            reLoadPage();
        }
        console.log(error);
        handleToast('error', error.response?.data?.message);
        throw error;
    }
}
export async function GetBeneficiaries() {
    return api.get('beneficiaries?f[status]=1', {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('login')}`
        }
    }) .then(res => { return res.data.data })
    .catch((error) => {
        if (error.request.status === 401) {
            reLoadPage()
        }
    })

}

export async function DeleteBeneficiary(id) {
    try {
        const res = await api.put(`beneficiaries/${id}`, { status: -1 }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': `Bearer ${localStorage.getItem('login')}`
            }
        });
        handleToast('success', 'ذینفع با موفقیت حذف شد');
        return res;
    } catch (error) {
        if (error.request?.status === 401) {
            reLoadPage();
        }
        console.log(error);
        handleToast('error', error.response?.data?.message);
        throw error;
    }
}
export async function CheckSheba() {
    return api2.post('?api=card_sheba&card=6037991199500590', {},{
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'Authorization': `Bearer 699005/4RtXVCvXZLBPhjoxl+/unSTGw797oy1cPvyoDDnLoqg=`
        }
    }) .then(res => { console.log(res.data.data); })
    .catch((error) => {
        if (error.request.status === 401) {
            reLoadPage()
        }
    })

}



export async function sendOtp(data) {
       api.post('send-otp',data,{
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('login')}`
        }   
       }).then((res) => {
        return res
    }).catch((error) => {
        if (error.request.status === 401) {
            localStorage.removeItem('login')
        }
    })
}